export const API_URL = process.env.GATSBY_API_URL
export const CDN_URL = process.env.GATSBY_CDN_URL
export const IMAGES_PATH = CDN_URL + "appimages/"
export const MARKETING_PATH = IMAGES_PATH + "marketing/"
export const NEWS_PATH = MARKETING_PATH + "news/"
export const RESOURCES_PATH = CDN_URL + "partner/"
export const VIDEOS_PATH = IMAGES_PATH + "videos/"
